import React, { useState } from "react"
import { Link } from "gatsby"
import { Button } from "semantic-ui-react"
import "./index.scss"

export default function ImageGrid({
  content,
  listContent,
  hideGrid,
  title,
  description,
  itemsPerRow,
}) {
  const [itemsToShow, setItemsToShow] = useState(6)

  if (!content.length) return null

  function onLoadMoreClick() {
    setItemsToShow(itemsToShow + 6)
  }

  return (
    <div className="image-grid-wrapper">
      {title && <h2 className="title">{title}</h2>}
      {description && <p className="description">{description}</p>}
      {!hideGrid && (
      <div
        className={`image-grid image-grid-${itemsPerRow}`}
        style={{
          gridTemplateColumns: `repeat(${itemsPerRow}, 1fr)`,
        }}
      >
        {content.slice(0, itemsToShow).map((c, i) => (
          <div
            className="image-grid-item"
            key={i}
            style={{
              background: `url(${c.image}) no-repeat center center`,
              backgroundSize: "cover",
            }}
          >
            <Link
              to={c.url}
              className={`content position-${c.position || "center"}`}
            >
              <span>{c.text}</span>
            </Link>
            {c.subtext && <p className="subtext">{c.subtext}</p>}
          </div>
        ))}
      </div>
      )}
      {itemsToShow < content.length && (
        <div style={{ textAlign: "center", margin: "1em 0" }}>
          <Button content="Load More" onClick={onLoadMoreClick} />
        </div>
      )}
      {listContent && (
        <div style={{ marginTop: "1em" }}>
          {content.map(c => (
            <div style={{ marginBottom: "1em" }}>
              <h3 style={{ marginBottom: "0" }}>
                <Link
                  to={c.url}
                  className={`content position-${c.position || "center"}`}
                >
                  {c.text}
                </Link>
              </h3>
              <p>{c.subtext}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

ImageGrid.defaultProps = {
  content: [],
  itemsPerRow: 2,
  listContent: false,
  hideGrid: false,
  title: "",
  description: "",
}
